// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3gOhd","head":"Table_head__33WF_","col":"Table_col__1fVNe"};